// components
import ContentLayout from "@/layouts/ContentLayout";
import TextBlock from "@/components/blocks/TextBlock";

// assets
import TitleBanner from "@/components/banners/TitleBanner";
import banner from "@/assets/images/why-us/banner.png";
import image1 from "@/assets/images/why-us/image1.png";
import image2 from "@/assets/images/why-us/image2.png";
import image3 from "@/assets/images/why-us/image3.png";
import image4 from "@/assets/images/why-us/image4.jpg";
import image5 from "@/assets/images/why-us/image5.png";
import image6 from "@/assets/images/why-us/image6.png";
import image7 from "@/assets/images/why-us/image7.png";
import image8 from "@/assets/images/why-us/image8.png";
import image9 from "@/assets/images/why-us/image9.png";
import globalProtectionLocalAgility from "@/assets/images/why-us/globalProtectionLocalAgility.png";
import esgAtOurCore from "@/assets/images/why-us/esgAtOurCore.png";
import handsOnCommitment from "@/assets/images/why-us/handsOnCommitment.png";
import partnersInSustainability from "@/assets/images/why-us/partnersInSustainability.png";

// i18n
import { useTranslation } from "react-i18next";
import StatisticCard from "@/components/cards/StatisticCard";
import { FaArrowRight } from "react-icons/fa";

const WhyUs = () => {
  const { t } = useTranslation();

  const workWithUs = [
    {
      title: "uco_buyers",
      descriptions: [
        "uco_buyers_description_1",
        "uco_buyers_description_2",
        "uco_buyers_description_3",
        "uco_buyers_description_4",
        "uco_buyers_description_5",
        "uco_buyers_description_6",
        "uco_buyers_description_7",
        "uco_buyers_description_8",
        "uco_buyers_description_9",
        "uco_buyers_description_10",
      ],
    },
    // { title: "our_credentials", descriptions: ["our_credentials_description_1", "our_credentials_description_2"] },
  ];

  const reasons = [
    {
      icon: globalProtectionLocalAgility,
      unitKey: "global_connection_diverse_perspectives",
      descriptionKey: "global_connection_diverse_perspectives_description",
    },
    {
      icon: globalProtectionLocalAgility,
      unitKey: "legal_protection",
      descriptionKey: "legal_protection_description",
    },
    {
      icon: globalProtectionLocalAgility,
      unitKey: "risk_control",
      descriptionKey: "risk_control_description",
    },
    {
      icon: globalProtectionLocalAgility,
      unitKey: "centralised_purchasing",
      descriptionKey: "centralised_purchasing_description",
    },
    {
      icon: globalProtectionLocalAgility,
      unitKey: "flexibility",
      descriptionKey: "flexibility_description",
    },
    {
      icon: globalProtectionLocalAgility,
      unitKey: "24_7_support",
      descriptionKey: "24_7_support_description",
    },
    {
      icon: esgAtOurCore,
      unitKey: "esg_at_our_core",
      descriptionKey: "esg_at_our_core_description",
    },
    {
      icon: handsOnCommitment,
      unitKey: "hands_on_commitment",
      descriptionKey: "hands_on_commitment_description",
    },
    {
      icon: partnersInSustainability,
      unitKey: "partners_in_sustainability",
      descriptionKey: "partners_in_sustainability_description",
    },
  ];

  return (
    <div className="w-full">
      <TitleBanner bannerImg={banner} title={t("why_us.why_us")} />
      <ContentLayout>
        <article className="flex w-full flex-col gap-9">
          <div className="flex flex-col gap-6">
            <div className="text-5xl font-bold text-primary">{t("why_us.why_planetrus")}</div>
            <div className="grid grid-cols-1 gap-9 sm:grid-cols-2 lg:grid-cols-3">
              {reasons.map((item, index) => (
                <StatisticCard
                  key={index}
                  icon={item.icon}
                  iconWidth="60px"
                  unit={t(`why_us.reasons.${item.unitKey}`)}
                  description={t(`why_us.reasons.${item.descriptionKey}`)}
                  padding="p-6"
                  borderRadius="rounded-2.5xl"
                />
              ))}
            </div>
          </div>
          <div className="flex flex-col gap-6">
            <div className="text-5xl font-bold text-primary">{t("why_us.work_with_us")}</div>
            {/* <figure className="mt-9 h-fit w-full overflow-hidden rounded-lg">
              <img src={image1} alt="about-us-image1" className="w-full object-cover" />
            </figure> */}
            <div className="flex w-full flex-col gap-12 lg:flex-row">
              {workWithUs.map((item, index) => (
                <TextBlock key={index} title={item.title} descriptions={item.descriptions} translationKey="why_us" />
              ))}
              <section className="flex w-full flex-col gap-6">
                <div className="flex w-full flex-col gap-6 md:flex-row">
                  <figure className="flex h-[300px] w-full items-center justify-center overflow-hidden">
                    <img src={image5} alt="office" className="hover-scale h-full w-full object-cover" />
                  </figure>
                  <figure className="flex h-[300px] w-full items-center justify-center overflow-hidden">
                    <img src={image6} alt="office" className="hover-scale h-full w-full object-cover" />
                  </figure>
                </div>
                <div className="flex w-full flex-col gap-6 md:flex-row">
                  <figure className="flex h-[300px] w-full items-center justify-center overflow-hidden">
                    <img src={image4} alt="office" className="hover-scale h-full w-full object-cover" />
                  </figure>
                  <figure className="flex h-[300px] w-full items-center justify-center overflow-hidden">
                    <img src={image7} alt="office" className="hover-scale h-full w-full object-cover" />
                  </figure>
                </div>
                <div className="flex w-full flex-col gap-6 md:flex-row">
                  <figure className="flex h-[300px] w-full items-center justify-center overflow-hidden">
                    <img src={image8} alt="office" className="hover-scale h-full w-full object-cover" />
                  </figure>
                  <figure className="flex h-[300px] w-full items-center justify-center overflow-hidden">
                    <img src={image9} alt="office" className="hover-scale h-full w-full object-cover" />
                  </figure>
                </div>
              </section>
            </div>

            <TextBlock
              title="our_credentials"
              descriptions={["our_credentials_description_1", "our_credentials_description_2"]}
              translationKey="why_us"
            />
            <section className="flex w-full gap-12">
              <figure className="flex h-[300px] w-[42%] items-center justify-center overflow-hidden">
                <img src={image1} alt="why-us-image1" />
              </figure>
              <figure className="flex h-[300px] w-[20%] items-center justify-center overflow-hidden">
                <img src={image2} alt="why-us-image2" />
              </figure>
              <figure className="flex h-[300px] w-[33%] items-center justify-center overflow-hidden">
                <img src={image3} alt="why-us-image3" />
              </figure>
            </section>
            {/* <button className="mt-6 flex w-fit items-center rounded-md bg-primary px-6 py-3 text-base font-bold text-white">
              {t("home.read_more")} <FaArrowRight className="ml-2" />
            </button> */}
          </div>
        </article>
      </ContentLayout>
    </div>
  );
};

export default WhyUs;
